/*
 * Layout for the quick create page
 */

define(["marionette", "modules/quickCreate/template/quickCreateTemplate.html"], function (
  Marionette,
  QuickCreateTemplate,
) {
  var QuickCreateView = {};

  QuickCreateView.quickCreateLayout = Marionette.Layout.extend({
    template: QuickCreateTemplate,
    regions: {
      quickCreateList: "#quickCreateList",
      quickCreateControls: "#quickCreateControls",
    },
    triggers: {
      "click #addTopic": "add:topic",
      "click #showDashboard": "show:dashboard",
    },
  });

  return QuickCreateView;
});
